<div class="container mb-5 marginMobile">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-8 col-lg-8 col-xl-10">
            <div class="card p-2">
                  <canvas #balance class="mb-5" height="300px"></canvas>
                  <div class="container">
                    <div class="row mt-5">
                      <div class="col-12 text-end">
                        <button type="button" class="generatePDF" name="button"><a href="http://102.53.9.162/ceratubeapi/ceratube/?token={{token}}"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> Générer PDF</a></button>
                      </div>
                    </div>
                    <div id="facture" class="row">
                      <div class="row">
                          <div class="col-md-12">
                            <input type="text" id="myInput" onkeyup="myFunction()" placeholder="Recherche.." title="Type in a name">
                          </div>
                      </div>
                      <div class="col-sm-12">

                        <div class="table-responsive">
                          <table id="tableBalance" class="table table-striped" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Numéro piéce</th>
                                    <th>Type de piéce</th>
                                    <th>Mantant</th>
                                    <th>Date d'échéanche</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let d of detailsData">
                                    <td>{{d.NUM}}</td>
                                    <td>{{d.TYP}}</td>
                                    <td>{{d.AMT}}</td>
                                    <td>{{d.DUDDAT|dateform}}</td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
